import { createFileRoute } from '@tanstack/react-router';
import { AutomationsFormSubmissionsForward } from '@/pages/workspaces/automations/[campaignId]/form-submissions/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/form-submissions',
)({
  component: AutomationsFormSubmissionsForward,
});
